import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "@/shared/libs/queryClient";
import { toast } from "@/shared/hooks/useToast";
import { cancelCollections, fetchCollectionStatus } from "@/api/collectionStatus";
import type { CancelCollectionRequest, CollectionStatusParams } from "@/types/collection-types";

const DEFAULT_PARAMS: CollectionStatusParams = {
  tab: "success",
  page: 1,
  page_size: 10,
};

/**
 * 수집 현황 조회 Query Hook
 */
export function useCollectionStatusQuery(params?: CollectionStatusParams) {
  const p = params ?? DEFAULT_PARAMS;

  return useQuery({
    queryKey: queryKeys.collectionStatus.status(p as unknown as Record<string, unknown>),
    queryFn: () => fetchCollectionStatus(p),
    refetchInterval: 30000, // 30초마다 자동 갱신
    placeholderData: (prev) => prev,
  });
}

/**
 * 수집 취소 Mutation Hook
 */
export function useCancelCollectionsMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (request: CancelCollectionRequest) => cancelCollections(request),
    onSuccess: (data) => {
      // 수집 현황 재조회
      queryClient.invalidateQueries({ queryKey: queryKeys.collectionStatus.all });

      toast({
        title: "수집 취소 요청 완료",
        description: data.message,
      });
    },
    onError: (error: Error) => {
      toast({
        title: "수집 취소 실패",
        description: error.message,
        variant: "destructive",
      });
    },
  });
}
